/**
 * User preference: PageGuide master on/off + first-use calibration flag.
 * Path: users/{userId}/preferences/pageGuide
 */

import { doc, getDoc, setDoc, serverTimestamp } from "firebase/firestore";
import { db } from "services/firebase";

const DEFAULT_PREFERENCES = {
  /** Master switch — default OFF so enabling is the audio-unlock gesture. */
  enabled: false,
  /** True after the first-use "can you hear this?" flow completes (either outcome). */
  heardCalibration: false,
};

const getPreferencesPath = (userId) => `users/${userId}/preferences/pageGuide`;

export async function getPageGuidePreferences(userId) {
  if (!userId) return { ...DEFAULT_PREFERENCES };

  try {
    const snap = await getDoc(doc(db, getPreferencesPath(userId)));
    if (!snap.exists()) return { ...DEFAULT_PREFERENCES };
    const data = snap.data() || {};
    return {
      ...DEFAULT_PREFERENCES,
      ...data,
      enabled: data.enabled === true,
      heardCalibration: data.heardCalibration === true,
    };
  } catch (err) {
    console.error("[PageGuidePreferences] load failed", err);
    return { ...DEFAULT_PREFERENCES };
  }
}

export async function savePageGuidePreferences(userId, partial) {
  if (!userId) return false;
  try {
    const current = await getPageGuidePreferences(userId);
    const merged = {
      ...current,
      ...partial,
      updatedAt: serverTimestamp(),
    };
    await setDoc(doc(db, getPreferencesPath(userId)), merged, { merge: true });
    return true;
  } catch (err) {
    console.error("[PageGuidePreferences] save failed", err);
    return false;
  }
}

export { DEFAULT_PREFERENCES as PAGE_GUIDE_DEFAULT_PREFERENCES };
